export const HOMEPAGE_ROUTE = '/'
export const ADMIN_ROUTE = '/admin'
export const LOGIN_ROUTE = '/login'
export const SHOP_ROUTE = '/shop'
export const BASKET_ROUTE = '/basket'
export const DETAIL_ROUTE = '/detail'
export const REGISTRATION_ROUTE = '/registration'
export const RENT_ROUTER = '/rent'
export const SERVICE_ROUTE = '/service'
export const FORKLIT_ROUTE = '/forklit'
export const DOCS_ROUTE = '/docs'
export const CONTACTS_ROUTE = '/contacts'
export const VACANCIES_ROUTE = '/vacancies'
export const SEND_EMAIL = 'api/send-email'
export const LIMIT_PER_PAGE = 24
